import { endOfMonth, endOfYear, startOfMonth, startOfYear, subDays, subMonths, subYears } from 'date-fns';

export function getDateRangeOptions() {
  const date = new Date();
  return [
    { title: 'Mes actual', from: startOfMonth(date), to: date },
    { title: 'Mes pasado', from: startOfMonth(subMonths(date, 1)), to: endOfMonth(subMonths(date, 1)) },
    { title: 'Año actual', from: startOfYear(date), to: date },
    { title: 'Año pasado', from: startOfYear(subYears(date, 1)), to: endOfYear(subYears(date, 1)) },
    { title: 'Últimos 7 días', from: subDays(date, 6), to: date },
    { title: 'Últimos 30 días', from: subDays(date, 29), to: date },
    { title: 'Últimos 3 meses', from: subMonths(date, 3), to: date },
    { title: 'Último año', from: subMonths(date, 11), to: date }
  ];
}
